"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const KeyCode = tslib_1.__importStar(require("../util/KeyboardEventCodes"));
// Component rendered in the user interface
// <div aria-controls="list-box" class="horizontal-tab" style="display: flex; flex-direction: column">
//   <header role="tablist" class="horizontal-tab-header">
//     <div id="tab-header1" role="tab" aria-controls="tab-content1" aria-selected="false"></div>
//     ...
//   </header>
//   <div class="horizontal-tab-content" style="display: flex; flex-direction: row">
//     <div id="tab-content1" aria-labelledby="tab-header1" role="tabpanel"></div>
//     ...
//   </div>
// </div>
// TODO: Upgrade to use HasValueWidget
class HorizontalValueTabCustomElement extends fmko_ts_common_1.WidgetCustomElement {
    static get observedAttributes() {
        return [fmko_ts_common_1.ARIA.HIDDEN];
    }
    constructor(props) {
        super(props);
        this.SIDE_WIDTH = 4;
        // private HEIGHT_WIDTH = 8;
        this.TRANSITION_TIMING_FUNCTION = 100;
        this.handlerManager = new fmko_ts_common_1.HandlerManager();
        this.tabChangeManager = new fmko_ts_common_1.HandlerManager();
        this.render();
    }
    connectedCallback() {
        if (!this.props) {
            throw new Error("HorizontalValueTabCustomElement has no props prior to being appended to the DOM");
        }
        this.renderTabSelector();
    }
    attributeChangedCallback() {
        this.renderTabSelector();
    }
    getValue() {
        return this.selected?.getValue();
    }
    setValue(tabContent, fireEvents) {
        const relevantValueTab = this.props.valueTabs.find(tab => tab.getContent() === tabContent);
        this.selectTab(relevantValueTab);
        if (fireEvents) {
            this.fireEvent(new fmko_ts_common_1.ValueChangeEvent(this.getValue()));
        }
    }
    addValueChangeHandler(handler) {
        return this.handlerManager.addHandler(handler);
    }
    fireEvent(event) {
        this.handlerManager.fireEvent(event);
    }
    addTabChangeHandler(handler) {
        return this.tabChangeManager.addHandler(handler);
    }
    fireTabChangeEvent(event) {
        this.tabChangeManager.fireEvent(event);
        // Dispatch change event allows dialog listeners to update tooltips
        this.dispatchEvent(new Event("change", { bubbles: true }));
    }
    getSelected() {
        return this.selected;
    }
    isEnabled() {
        return (0, fmko_ts_common_1.isEnabled)(this);
    }
    setEnabled(enabled) {
        (0, fmko_ts_common_1.setEnabled)(this, enabled);
        for (const tab of this.props.valueTabs) {
            (0, fmko_ts_common_1.setEnabled)(tab.getTabElement(), enabled);
        }
    }
    setTabVisible(tabContent, visible) {
        const valueTab = this.props.valueTabs.find(tab => tab.getContent() === tabContent);
        if (valueTab === this.selected && !visible) {
            return; // Don't hide if the current tab is selected
        }
        const tabElement = valueTab.getTabElement();
        (0, fmko_ts_common_1.setElementVisible)(tabElement, visible);
    }
    setTabHeaderVisible(visible) {
        (0, fmko_ts_common_1.setElementVisible)(this.tabHeader, visible);
    }
    setTabEnabled(tabContent, enabled) {
        const valueTab = this.props.valueTabs.find(tab => tab.getContent() === tabContent);
        if (valueTab === this.selected && !enabled) {
            return; // Don't disable if the current tab is selected
        }
        const tabElement = valueTab.getTabElement();
        (0, fmko_ts_common_1.setEnabled)(tabElement, enabled);
        if (this.props.valueTabs.some(tab => (0, fmko_ts_common_1.isEnabled)(tab.getTabElement()))) {
            (0, fmko_ts_common_1.setEnabled)(this, true);
        }
        tabElement.tabIndex = enabled ? 0 : -1;
    }
    updateTabHeaders() {
        for (const valueTab of this.props.valueTabs) {
            const tabElement = valueTab.getTabElement();
            tabElement.textContent = valueTab.getTabName();
            tabElement.dataset.boldedText = valueTab.getTabName();
        }
    }
    selectTab(valueTab, fireEvent) {
        if (this.selected) {
            this.selected.getTabElement().setAttribute(fmko_ts_common_1.ARIA.SELECTED, "false");
            (0, fmko_ts_common_1.setElementVisible)(this.selected.getContent().element, false);
        }
        if (valueTab) {
            const tabElement = valueTab.getTabElement();
            const tabContentElement = valueTab.getContent().element;
            tabElement.setAttribute(fmko_ts_common_1.ARIA.SELECTED, "true");
            if (!this.tabContentContainer.contains(tabContentElement)) {
                this.tabContentContainer.appendChild(tabContentElement);
            }
            (0, fmko_ts_common_1.setElementVisible)(tabContentElement, true);
        }
        this.selected = valueTab;
        this.renderTabSelector(undefined);
        if (fireEvent && this.handlerManager.getHandlerCount()) {
            this.fireEvent(new fmko_ts_common_1.ValueChangeEvent(valueTab?.getValue()));
        }
        this.fireTabChangeEvent(new fmko_ts_common_1.ValueChangeEvent(valueTab?.getContent()));
    }
    render() {
        const { selectedTab, selectFirstTabAutomatically = true, valueTabs, testIdentifier } = this.props;
        this.classList.add("horizontal-tab");
        this.tabHeader = document.createElement("div");
        this.tabHeader.classList.add("horizontal-tab-header", "horizontal-value-tab-header");
        this.tabHeader.addEventListener("hover", () => {
            this.renderTabSelector();
        });
        this.tabHeader.setAttribute("role", fmko_ts_common_1.ARIARole.TAB_LIST);
        if (testIdentifier) {
            this.tabHeader.dataset.cy = testIdentifier;
        }
        this.tabContentContainer = document.createElement("div");
        this.tabContentContainer.classList.add("horizontal-tab-content");
        for (const valueTab of valueTabs) {
            const tabElementId = fmko_ts_common_1.GlobalCounter.next();
            const tabContentId = fmko_ts_common_1.GlobalCounter.next();
            const tabElement = valueTab.getTabElement();
            tabElement.id = tabElementId;
            tabElement.textContent = valueTab.getTabName();
            tabElement.dataset.boldedText = valueTab.getTabName();
            tabElement.classList.add("horizontal-value-tab-button");
            tabElement.setAttribute("role", fmko_ts_common_1.ARIARole.TAB);
            tabElement.setAttribute(fmko_ts_common_1.ARIA.SELECTED, "false");
            tabElement.setAttribute(fmko_ts_common_1.ARIA.CONTROLS, tabContentId);
            const tabContentElement = valueTab.getContent().element;
            tabContentElement.id = tabContentId;
            tabContentElement.setAttribute("role", fmko_ts_common_1.ARIARole.TAB_PANEL);
            tabContentElement.setAttribute(fmko_ts_common_1.ARIA.LABELLED_BY, tabElementId);
            valueTab.addValueChangeHandler(handler => {
                const value = handler.getValue();
                if (valueTab === this.getSelected()) {
                    this.fireEvent(new fmko_ts_common_1.ValueChangeEvent(value));
                }
            });
            tabElement.addEventListener("click", () => {
                this.selectTab(valueTab, true);
            });
            tabElement.addEventListener("keydown", event => {
                if (!event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey) {
                    if (KeyCode.isArrowLeft(event)) {
                        this.focusEnabledAdjacentSibling(tabElement, "previous");
                    }
                    else if (KeyCode.isArrowRight(event)) {
                        this.focusEnabledAdjacentSibling(tabElement, "next");
                    }
                }
            });
            this.tabHeader.appendChild(tabElement);
            if (valueTab === selectedTab && !valueTab.getTabElement().disabled) {
                this.selectTab(valueTab, true);
            }
        }
        this.tabSelector = document.createElement("div");
        this.tabSelector.classList.add("horizontal-tab-selector");
        this.tabHeader.appendChild(this.tabSelector);
        if (!selectedTab && selectFirstTabAutomatically) {
            const firstTab = valueTabs?.find(valueTab => !valueTab.getTabElement().disabled);
            if (firstTab) {
                this.selectTab(firstTab, true);
            }
        }
        this.appendChild(this.tabHeader);
        this.appendChild(this.tabContentContainer);
    }
    focusEnabledAdjacentSibling(element, direction, originalElement) {
        if (element === originalElement) {
            return; // We have iterated through the entire list of children
        }
        const relevantOriginalElement = originalElement || element;
        const adjacentSiblingKey = direction === "previous" ? "previousElementSibling" : "nextElementSibling";
        const firstLastKey = direction === "previous" ? "lastElementChild" : "firstElementChild";
        const adjacentSibling = element[adjacentSiblingKey];
        if (adjacentSibling) {
            this.focusIfEnabled(direction, adjacentSibling, relevantOriginalElement);
        }
        else {
            const tabElementParent = element.parentElement;
            if (tabElementParent) {
                const firstLastChild = tabElementParent[firstLastKey];
                this.focusIfEnabled(direction, firstLastChild, relevantOriginalElement);
            }
        }
    }
    focusIfEnabled(direction, element, originalElement) {
        if (element) {
            if (!element.hasAttribute("disabled")) {
                element.focus();
            }
            else {
                // If it's the first recursion then add element as original element
                this.focusEnabledAdjacentSibling(element, direction, originalElement);
            }
        }
    }
    renderTabSelector(element, disableTransition) {
        if (!this.tabSelector) {
            return; // selectedTab sets the selected tab before element is appended to dom, thus has not been rendered
        }
        if (disableTransition) {
            this.tabSelector.classList.add("disable-transition");
        }
        const relevantElement = element || this.selected?.getTabElement();
        if (relevantElement) {
            const { left: tabHeaderLeft } = this.tabHeader.getBoundingClientRect();
            const { left: relevantElementLeft, height, width } = relevantElement.getBoundingClientRect();
            const tabSelectorLeft = relevantElementLeft - tabHeaderLeft;
            this.tabSelector.style.height = `${fmko_ts_common_1.REMCalculator.pxToRem(height + this.SIDE_WIDTH)}rem`;
            this.tabSelector.style.width = `${fmko_ts_common_1.REMCalculator.pxToRem(width + this.SIDE_WIDTH)}rem`;
            this.tabSelector.style.left = `${fmko_ts_common_1.REMCalculator.pxToRem(tabSelectorLeft - this.SIDE_WIDTH)}rem`;
        }
        if (disableTransition) {
            setTimeout(() => {
                this.tabSelector.classList.remove("disable-transition");
            }, this.TRANSITION_TIMING_FUNCTION);
        }
    }
}
customElements.define(`horizontal-value-tab-${fmko_ts_common_1.GlobalCounter.next()}`, HorizontalValueTabCustomElement);
exports.default = HorizontalValueTabCustomElement;
//# sourceMappingURL=HorizontalValueTabCustomElement.js.map